import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer bg-success",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#register_trainee",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder text-light m-0" }, "Map Batch Assessor")
  ])
], -1)
const _hoisted_3 = {
  id: "register_trainee",
  class: "collapse show"
}
const _hoisted_4 = { class: "collapse show" }
const _hoisted_5 = { class: "card-body border-top p-4" }
const _hoisted_6 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-md-2" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Tranche", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = { class: "col-md-2" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Association", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_14 = { class: "col-md-3" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Training Institutes", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_17 = { class: "col-md-3" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Training Courses", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_20 = { class: "col-md-2" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Courses Batch", -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_23 = { class: "row mt-5 pt-3" }
const _hoisted_24 = {
  key: 0,
  class: "col-md-5"
}
const _hoisted_25 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Unmapped Assessors", -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_27 = ["value"]
const _hoisted_28 = {
  key: 1,
  class: "col-md-2"
}
const _hoisted_29 = { class: "row mt-2" }
const _hoisted_30 = { class: "col-md-6 text-end" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-angle-right fs-3" }, null, -1)
const _hoisted_32 = [
  _hoisted_31
]
const _hoisted_33 = { class: "col-md-6" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-angle-left fs-3" }, null, -1)
const _hoisted_35 = [
  _hoisted_34
]
const _hoisted_36 = { class: "row" }
const _hoisted_37 = { class: "col-md-6 text-end" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-angle-double-right fs-3" }, null, -1)
const _hoisted_39 = [
  _hoisted_38
]
const _hoisted_40 = { class: "col-md-6" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-angle-double-left fs-3" }, null, -1)
const _hoisted_42 = [
  _hoisted_41
]
const _hoisted_43 = {
  key: 2,
  class: "col-md-5"
}
const _hoisted_44 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Mapped Assessors", -1)
const _hoisted_45 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_46 = ["value"]
const _hoisted_47 = {
  key: 3,
  class: "row mt-3"
}
const _hoisted_48 = { class: "col-md-12" }
const _hoisted_49 = { class: "d-flex" }
const _hoisted_50 = ["data-kt-indicator"]
const _hoisted_51 = {
  key: 0,
  class: "indicator-label"
}
const _hoisted_52 = { class: "svg-icon svg-icon-3 ms-2 me-0" }
const _hoisted_53 = {
  key: 1,
  class: "indicator-progress"
}
const _hoisted_54 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createBlock(_component_Form, {
    onSubmit: _cache[14] || (_cache[14] = ($event: any) => (_ctx.formSubmit())),
    class: "form",
    "validation-schema": _ctx.AssociationSchema
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _hoisted_9,
                    _hoisted_10,
                    _createVNode(_component_el_select, {
                      class: "form-select-solid",
                      placeholder: "Select Tranche",
                      modelValue: _ctx.batch.tranche_id,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.batch.tranche_id) = $event)),
                      filterable: "",
                      style: {"width":"100%"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_option, {
                          label: "Tranche-1",
                          value: "1"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Tranche-1")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_option, {
                          label: "Tranche-2",
                          value: "2"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Tranche-2")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_option, {
                          label: "Tranche-3",
                          value: "3"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Tranche-3")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_option, {
                          label: "Tranche-4",
                          value: "4"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Tranche-4")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _hoisted_12,
                    _createTextVNode(),
                    _hoisted_13,
                    _createVNode(_component_el_select, {
                      class: "form-select-solid",
                      placeholder: "Select Association",
                      modelValue: _ctx.batch.entity_id,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.batch.entity_id) = $event)),
                      filterable: "",
                      style: {"width":"100%"}
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.entityInfos, (info) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: info.id,
                            label: info.entity_name,
                            value: info.id
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(info.entity_name), 1)
                            ]),
                            _: 2
                          }, 1032, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    _hoisted_15,
                    _hoisted_16,
                    _createVNode(_component_el_select, {
                      class: "form-select-solid",
                      placeholder: "Select Training Institutes",
                      modelValue: _ctx.batch.institute_id,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.batch.institute_id) = $event)),
                      filterable: "",
                      style: {"width":"100%"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_option, {
                          label: "A.B.C Bangladesh-Turkish Technical School",
                          value: "1"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("A.B.C Bangladesh-Turkish Technical School")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_option, {
                          label: "ACA Technical Institute",
                          value: "2"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("ACA Technical Institute")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_option, {
                          label: "Ahsan Jamil Technical Center",
                          value: "3"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Ahsan Jamil Technical Center")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_17, [
                    _hoisted_18,
                    _hoisted_19,
                    _createVNode(_component_el_select, {
                      class: "form-select-solid",
                      placeholder: "Select Training Course",
                      modelValue: _ctx.batch.course_id,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.batch.course_id) = $event)),
                      filterable: "",
                      onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.assessorList())),
                      style: {"width":"100%"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_option, {
                          label: "Welding & Fabrication (NE)",
                          value: "1"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Welding & Fabrication (NE)")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_option, {
                          label: "Electrical & Navigation Equipment Installation (NE)",
                          value: "2"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Electrical & Navigation Equipment Installation (NE)")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_20, [
                    _hoisted_21,
                    _hoisted_22,
                    _createVNode(_component_el_select, {
                      class: "form-select-solid",
                      placeholder: "Select Course Batch",
                      modelValue: _ctx.batch.batch_id,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.batch.batch_id) = $event)),
                      filterable: "",
                      onChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.assessorMapList())),
                      style: {"width":"100%"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_option, {
                          label: "1",
                          value: "1"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("1")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_option, {
                          label: "2",
                          value: "2"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("2")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_option, {
                          label: "3",
                          value: "2"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("3")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_option, {
                          label: "4",
                          value: "2"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("4")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_23, [
                  ((_ctx.showAssessorList == true))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                        _hoisted_25,
                        _hoisted_26,
                        _withDirectives(_createElementVNode("select", {
                          class: "form-control",
                          multiple: "",
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.assessor_ids) = $event)),
                          size: "12",
                          style: {"height":"250px !important","overflow":"auto"}
                        }, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.assessorInfo, (assessor) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: assessor.id,
                              value: { id: assessor.id, name: assessor.name }
                            }, _toDisplayString(assessor.name), 9, _hoisted_27))
                          }), 128))
                        ], 512), [
                          [_vModelSelect, _ctx.assessor_ids]
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  ((_ctx.showAssessorList == true) && (_ctx.showMapAssessorList == true))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                        _createElementVNode("div", _hoisted_29, [
                          _createElementVNode("div", _hoisted_30, [
                            _createElementVNode("button", {
                              type: "button",
                              onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.selectedAssessor())),
                              class: "btn btn-success mt-5 px-7"
                            }, _hoisted_32)
                          ]),
                          _createElementVNode("div", _hoisted_33, [
                            _createElementVNode("button", {
                              type: "button",
                              onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.unselectedAssessor())),
                              class: "btn btn-success mt-5 px-7"
                            }, _hoisted_35)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_36, [
                          _createElementVNode("div", _hoisted_37, [
                            _createElementVNode("button", {
                              type: "button",
                              onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.selectedAllAssessor())),
                              class: "btn btn-danger mt-5"
                            }, _hoisted_39)
                          ]),
                          _createElementVNode("div", _hoisted_40, [
                            _createElementVNode("button", {
                              type: "button",
                              onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.unselectedAllAssessor())),
                              class: "btn btn-danger mt-5"
                            }, _hoisted_42)
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  ((_ctx.showMapAssessorList == true))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                        _hoisted_44,
                        _hoisted_45,
                        _withDirectives(_createElementVNode("select", {
                          class: "form-control",
                          multiple: "",
                          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.select_assessor_ids) = $event)),
                          size: "12",
                          style: {"height":"250px !important","overflow":"auto"}
                        }, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.assessorSelected, (course) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: course.id,
                              value: { id: course.id, name: course.name }
                            }, _toDisplayString(course.name), 9, _hoisted_46))
                          }), 128))
                        ], 512), [
                          [_vModelSelect, _ctx.select_assessor_ids]
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  ((_ctx.showAssessorList == true) && (_ctx.showMapAssessorList == true))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                        _createElementVNode("div", _hoisted_48, [
                          _createElementVNode("div", _hoisted_49, [
                            _createElementVNode("div", null, [
                              _createElementVNode("button", {
                                "data-kt-indicator": _ctx.loading ? 'on' : null,
                                class: "btn btn-lg btn-success",
                                type: "submit",
                                onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.formSubmit()))
                              }, [
                                (!_ctx.loading)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_51, [
                                      _createTextVNode(" Submit "),
                                      _createElementVNode("span", _hoisted_52, [
                                        _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr064.svg" })
                                      ])
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.loading)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_53, [
                                      _createTextVNode(" Please wait... "),
                                      _hoisted_54
                                    ]))
                                  : _createCommentVNode("", true)
                              ], 8, _hoisted_50)
                            ])
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["validation-schema"]))
}